
define('template!adminColorSelectionsLibrariesPopupView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="popup-body">\n  <div class="sl-side">\n    <div class="sl-new">\n      <input type="text" class="form-control js-new-name" maxlength="255" placeholder="' +
((__t = ( _.escape(labels.newPlaceholder) )) == null ? '' : __t) +
'"/>\n      <button type="button" class="btn btn-primary js-create"><i class="fa fa-plus"></i> ' +
((__t = ( _.escape(labels.create) )) == null ? '' : __t) +
'</button>\n    </div>\n    <div class="sl-list js-libraries"></div>\n    <div class="cs-hint">' +
((__t = ( _.escape(labels.sideHint) )) == null ? '' : __t) +
'</div>\n  </div>\n\n  <div class="sl-main js-main">\n    <div class="cs-empty">' +
((__t = ( _.escape(labels.pick) )) == null ? '' : __t) +
'</div>\n  </div>\n</div>\n\n<div class="error-box js-error" style="display: none;"></div>\n\n<div class="popup-footer">\n  <button type="button" class="btn js-close">' +
((__t = ( _.escape(labels.close) )) == null ? '' : __t) +
'</button>\n</div>\n';

}
return __p
};});

